import React, { useEffect, useState } from "react";

import * as AuthService from "../../services/auth";
import { useFormik } from "formik";
import { Button, Col, Container, Form, FormFeedback, Input, Label } from "reactstrap";
import { Footer } from "../../components/Footer";
import Header from "../../components/Header";
import * as yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import VerticalLayout from "../../components/VerticalLayout";

const Login = () => {
  const navigate = useNavigate();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: ""
    },
    validationSchema: yup.object({
      email: yup.string().email("Email invalide").required("Email obligatoire"),
      password: yup.string().required("mot de passe obligatoire")
    }),
    onSubmit: (values) => {
      AuthService.login(values)
        .then((res) => {
          console.log('User object received by frontend:', res.data.user);
          // The actual API data is in res.data
          localStorage.setItem("user", JSON.stringify(res.data.user));
          localStorage.setItem("token", res.data.access_token);
          navigate("/");
        })
        .catch((error) => {
          // Log the detailed error from the backend
          console.error("Login failed:", error.response?.data || error.message);
          const errorMessage = error.response?.data?.message || "Identifiants incorrects";
          toast.error(errorMessage);
        });
    }
  });

  return (
    <>
      <VerticalLayout />

      <div className="body mb-0">
        <Header />

        <ToastContainer />
        <div className="contact-form bg-main-container h-100">
          <div className="main-container scrollable">
            <Container className="width-form">
              <div className="no-filter-box rounded p-4">
                <h2 className="text-white ">Bienvenue !</h2>
                <Form
                  onSubmit={validation.handleSubmit}
                  className="mt-5">
                  <Col className="text-start m-3">
                    <Input
                      required
                      className="w-100"
                      id="email"
                      name="email"
                      type="text"
                      invalid={validation.touched.email && validation.errors.email}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email}
                    />
                    <label for="Email">Email</label>
                  </Col>
                  <Col className="text-start m-3 mt-4">
                    <Input
                      required
                      className="w-100"
                      id="password"
                      name="password"
                      type="password"
                      invalid={validation.touched.password && validation.errors.password}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.password}
                    />
                 
                    <label for="Email">Mot de passe</label>
                  </Col>
                  <div className="d-flex m-2">
                    <Link
                      className="text-decoration-none"
                      to={"/register"}>
                      <p className="text-white">Pas inscrit ? rejoignez-nous !</p>
                    </Link>
                  </div>
                  <Button
                    color="light"
                    className="">
                    Connexion
                  </Button>
                </Form>
              </div>
            </Container>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
